module.exports = __webpack_public_path__ + "static/media/SubmitIcon.2bf54c87.svg";